<template>

    <div class="text-center ">
        <div class="personalize-card">
            <div style="font-weight:bold;" class="step-1-title">
                Enter the name of the lucky journal owner
            </div>
            <div class="step-1-subtitle"><small>(optional)</small></div>
             <div class="mt-4">
                <b-form-input v-model="JournalOwner" placeholder="Enter name"></b-form-input>
                
            </div>
            <div class="mt-4 mb-4">
                <button class="btn btn-sm btn-primary" v-on:click="ValidateStep1()">Continue <b-icon icon="arrow-right"></b-icon></button>
            </div>
            <b-alert class="alert" variant="danger" :show="showError" @dismissed="dismissed()" dismissible fade>{{errorMsg}}</b-alert>
        </div>
    </div>
</template>



<script>
export default {
    data: function () {
        return {
            counter: 0,
            errorMsg:null,
            showError:0,
            JournalOwner:null
        }
    },
    methods:{
        ValidateStep1: function(){
            this.$emit('updateStep1', this.JournalOwner)
        },
        dismissed: function(){
            this.showError = 0;
        }
    }
}
</script>
